export const blockIconsAudioandvideoVideoLibraryNew = (
	<span className='material-symbols-outlined'>video_library</span>
);
